import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Edit from "../../../assets/icon/NewsIcons/MainAdmin/NewsEdit"
import Block from "../../../assets/icon/NewsIcons/MainAdmin/NewsBlock"
import Delete from "../../../assets/icon/NewsIcons/MainAdmin/NewsDelete"
import Detail from "../../../assets/icon/NewsIcons/MainAdmin/NewsDetail";
import { ReactComponent as Right } from "../../../assets/icon/right.svg";
import { ReactComponent as Left } from "../../../assets/icon/left.svg";
import moment from 'jalali-moment'
import { axiosReq } from "../../../commons/axiosReq";
import { DeleteModalArticle } from "../../../components"
import Cookies from 'universal-cookie';
import { Link } from "react-router-dom";
import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"

export const truncate = (str, len) => {
    if (str?.length > len && str?.length > 0) {
        let new_str = str + " ";
        new_str = str?.substr(0, len);
        new_str = str?.substr(0, new_str.lastIndexOf(" "));
        new_str = new_str.length > 0 ? new_str : str?.substr(0, len);
        return new_str + "...";
    }
    return str;
};
const MainAdminTables = ({ detail, setting, edit, block, deleted, titleRow, data, setShowSettingModal, setShowEditModal,
    setShowBlockModal, setData, confirm, setRecheck, reCheck,
    count, page, setPage, row, setRow }) => {
    const [id, setID] = useState();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const cookies = new Cookies();
    const [showAddModal, setShowAddModal] = useState(false);
    const [des, setDes] = useState();


    let navigate = useNavigate()

    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);


    return (
        <div className="rounded-[15px] pt-[15px] px-[15px] pb-[120px] border-borderGray border-2 w-full">
            <table className="w-full">
                {
                    titleRow ?
                        <tr className="h-[60px] w-full bg-lightBlue2">
                            <th className="rounded-r-[15px] text-right pr-[17px] text-[15px] font-IRANYekanBold text-mainColor2">ردیف</th>
                            <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[0]}</th>
                            <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[1]}</th>
                            <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[2]}</th>
                            <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[3]}</th>
                            {/* <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[4]}</th> */}
                            {/* <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[5]}</th> */}
                            {/* <th className="rounded-l-[15px] text-center pl-[17px] text-[15px] font-IRANYekanBold text-mainColor2">عملیات</th> */}
                        </tr>
                        :
                        null
                }
                {
                    data?.length > 0 ?
                        data?.map((item, index) => {
                            return (
                                <tr className="h-[56px] w-full border-b-2 border-borderGray">
                                    <th className="text-[15px] text-right pr-[17px] font-IRANYekanBold">{index + 1 + ((page - 1) * row)}</th>
                                    <th className="text-[15px] text-right font-IRANYekanBold">{item?.description?truncate(item?.description?.substring(5,item?.description?.length)+"-"+item?.userLogType.title+" ", 60):
                                        item?.userLogType.title
                                        }</th>
                                    {/* <th className="text-[15px] text-right font-IRANYekanBold">{item.articleCategories.map((item) => {
                                        return (
                                            item?.category?.categoryName + ","
                                        )
                                    })}</th> */}
                                    <th className="text-[15px] text-right font-IRANYekanBold">
                                        {item?.date ?
                                            moment(item?.date?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD') + " " +
                                            item?.date?.split("T")[1].substr(0, 5) : null}
                                    </th>
                                    <th className="text-[15px] text-right font-IRANYekanBold">
                                        {
                                            item.user?.name + " " + item.user?.family
                                        }</th>
                                    {/* <th className="text-[15px] text-right font-IRANYekanBold">{item?.datePublished}</th> */}
                                    {/* <th className="text-[15px] text-right font-IRANYekanBold">{item?.password}</th> */}
                                    <th><div className="flex pl-[17px] justify-center items-center">
                                        {detail == true ?
                                            <button onClick={() => { setShowAddModal(true); setDes(item.description) }} className="ml-[11px]"><Detail /></button>
                                            : null}

                                        {setting == true && confirm == true ?
                                            <button onClick={() => { navigate("/mainAdmin/editNews/release", { state: { accept: true, id: item?.slug, name: item?.articleCategories[0]?.item?.category?.categoryName + "/" + item?.slug } }) }} className="ml-[11px]">

                                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2707 2C9.86736 2 8.7297 3.13766 8.7297 4.54104C8.7297 4.74442 8.58945 5.01577 8.25424 5.19782C8.15109 5.25384 8.04936 5.3121 7.94912 5.37253C7.6148 5.57407 7.30096 5.56113 7.1167 5.4557C5.8929 4.75548 4.3334 5.17333 3.62365 6.39163L2.91923 7.60077C2.20812 8.82141 2.62778 10.3877 3.85393 11.0892C4.0317 11.191 4.19885 11.4497 4.19071 11.8346C4.18955 11.8896 4.18896 11.9448 4.18896 12C4.18896 12.0553 4.18955 12.1104 4.19071 12.1654C4.19885 12.5504 4.03171 12.8091 3.85395 12.9108C2.62781 13.6123 2.20815 15.1786 2.91926 16.3992L3.6237 17.6084C4.33345 18.8267 5.89293 19.2445 7.11673 18.5443C7.30099 18.4389 7.61481 18.4259 7.94912 18.6275C8.04936 18.6879 8.15109 18.7462 8.25424 18.8022C8.58945 18.9842 8.7297 19.2556 8.7297 19.459C8.7297 20.8623 9.86736 22 11.2707 22H12.7294C14.1328 22 15.2704 20.8623 15.2704 19.459C15.2704 19.2556 15.4107 18.9842 15.7459 18.8022C15.849 18.7462 15.9508 18.6879 16.051 18.6275C16.3853 18.4259 16.6991 18.4389 16.8834 18.5443C18.1072 19.2445 19.6667 18.8267 20.3764 17.6084L21.0809 16.3992C21.792 15.1786 21.3723 13.6123 20.1462 12.9108C19.9684 12.8091 19.8013 12.5504 19.8094 12.1654C19.8106 12.1104 19.8112 12.0552 19.8112 12C19.8112 11.9448 19.8106 11.8896 19.8094 11.8346C19.8013 11.4496 19.9684 11.1909 20.1462 11.0892C21.3724 10.3877 21.792 8.8214 21.0809 7.60076L20.3765 6.39162C19.6667 5.17332 18.1072 4.75547 16.8834 5.45569C16.6992 5.56113 16.3853 5.57406 16.051 5.37252C15.9508 5.31209 15.8491 5.25384 15.7459 5.19782C15.4107 5.01577 15.2704 4.74442 15.2704 4.54104C15.2704 3.13766 14.1328 2 12.7294 2H11.2707ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z" fill="#000000" />
                                                </svg>
                                            </button>
                                            : null}
                                        {setting == true && confirm != true ?
                                            <button onClick={() => { setShowSettingModal(true); setData(item) }} className="ml-[11px]">

                                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2707 2C9.86736 2 8.7297 3.13766 8.7297 4.54104C8.7297 4.74442 8.58945 5.01577 8.25424 5.19782C8.15109 5.25384 8.04936 5.3121 7.94912 5.37253C7.6148 5.57407 7.30096 5.56113 7.1167 5.4557C5.8929 4.75548 4.3334 5.17333 3.62365 6.39163L2.91923 7.60077C2.20812 8.82141 2.62778 10.3877 3.85393 11.0892C4.0317 11.191 4.19885 11.4497 4.19071 11.8346C4.18955 11.8896 4.18896 11.9448 4.18896 12C4.18896 12.0553 4.18955 12.1104 4.19071 12.1654C4.19885 12.5504 4.03171 12.8091 3.85395 12.9108C2.62781 13.6123 2.20815 15.1786 2.91926 16.3992L3.6237 17.6084C4.33345 18.8267 5.89293 19.2445 7.11673 18.5443C7.30099 18.4389 7.61481 18.4259 7.94912 18.6275C8.04936 18.6879 8.15109 18.7462 8.25424 18.8022C8.58945 18.9842 8.7297 19.2556 8.7297 19.459C8.7297 20.8623 9.86736 22 11.2707 22H12.7294C14.1328 22 15.2704 20.8623 15.2704 19.459C15.2704 19.2556 15.4107 18.9842 15.7459 18.8022C15.849 18.7462 15.9508 18.6879 16.051 18.6275C16.3853 18.4259 16.6991 18.4389 16.8834 18.5443C18.1072 19.2445 19.6667 18.8267 20.3764 17.6084L21.0809 16.3992C21.792 15.1786 21.3723 13.6123 20.1462 12.9108C19.9684 12.8091 19.8013 12.5504 19.8094 12.1654C19.8106 12.1104 19.8112 12.0552 19.8112 12C19.8112 11.9448 19.8106 11.8896 19.8094 11.8346C19.8013 11.4496 19.9684 11.1909 20.1462 11.0892C21.3724 10.3877 21.792 8.8214 21.0809 7.60076L20.3765 6.39162C19.6667 5.17332 18.1072 4.75547 16.8834 5.45569C16.6992 5.56113 16.3853 5.57406 16.051 5.37252C15.9508 5.31209 15.8491 5.25384 15.7459 5.19782C15.4107 5.01577 15.2704 4.74442 15.2704 4.54104C15.2704 3.13766 14.1328 2 12.7294 2H11.2707ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z" fill="#000000" />
                                                </svg>
                                            </button>
                                            : null}

                                        {edit == true ?
                                            <button onClick={() => { navigate("/mainAdmin/editNews/release", { state: { id: item?.slug } }) }} className="ml-[11px]"><Edit /></button>
                                            : null}
                                        {block == true ?
                                            <button onClick={() => { setShowBlockModal(true); setData(item) }} className="ml-[11px]"><Block /></button>
                                            : null}
                                        {deleted == true && cookies.get('role') == "Admin" ?
                                            // <button onClick={() => { setShowDeleteModal(true); setID(item) }} ><Delete /></button>
                                            <button onClick={() => { setShowDeleteModal(true); setID(item?.articleId) }}><Delete /></button>
                                            : null}
                                    </div></th>
                                </tr>
                            )
                        })
                        :
                        null}


            </table>
            <div className="  w-full py-3 px-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <p className="text-sm text-right px-4 font-IRANYekanMedium">
                            تعداد ردیف در هر صفحه :
                        </p>
                        <div className="flex flex-col w-[80px] ml-20 font-IRANYekanMedium">
                            <div class=" ">

                                <select
                                    name="rowNumber"
                                    id="rowNumber"
                                    onChange={(e) => { setRow(e.target.value); setPage(1) }}
                                    className="   text-right  bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full px-2 py-1">
                                    <option value="5" className=" ">۵ </option>
                                    <option value="10" selected className=" ">۱۰</option>
                                    <option value="25" className=" ">۲۵</option>


                                </select>
                                {/* <input
                              type="text"
                              id="input-group-1"
                              disabled="true"
                              class="pr-9   text-right right-6 bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full pl-10 p-2.5  "
                              placeholder="آرمان"/> */}
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center font-IRANYekanMedium">

                        <p className="text-sm text-right pr-4 mx-2">
                            {((page - 1) * row) + 1}-{count < row * page ? count : row * page} از {count}
                        </p>
                        <div className="flex mr-2">
                            <button onClick={() => setPage(page + 1)} disabled={count < row * page ? true : false} className="mx-2">
                                <Right />
                            </button>
                            <button onClick={() => setPage(page - 1)} disabled={page == 1 ? true : false} className="mx-2">
                                <Left />
                            </button>
                        </div>
                    </div>
                </div>

            </div>


            {
                showAddModal ?
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                    >
                        <div className="relative w-[30%] my-5 mx-auto ">

                            <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                                    {/* <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p> */}
                                    <button onClick={() => setShowAddModal(false)}><Cross /></button>
                                </div>
                                <div className="flex justify-center items-center w-full mt-[23px] mb-[43px]">
                                    <p className="font-IRANYekanBold text-[15px]">{des}</p>
                                </div>
                                <div className="flex justify-center">
                                    <button onClick={() => setShowAddModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                                </div>
                            </div>
                        </div>

                    </div>
                    :
                    null

            }
            {showDeleteModal ?
                <DeleteModalArticle title={'حذف خبر'} buttonName={'حذف'} id={id} reCheck={reCheck} setRecheck={setRecheck}
                    text={'آیا از حذف خبر انتخاب شده اطمینان دارید ؟'} setShowModal={setShowDeleteModal} /> : null}

        </div>
    )
}

export default MainAdminTables;